import { defineInjectable } from './Injectable.js';
/** Default injectable request transport backed by the current runtime's global fetch. */
export const Fetch = defineInjectable(() => globalThis.fetch);
//# sourceMappingURL=Fetch.js.map